module.exports = __webpack_public_path__ + "static/img/xiaowenjie.31dbe60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/e-wap/xiaowenjie.png
// module id = 14
// module chunks = 0